let pageStartTime = Date.now();
let lastTrackedUrl = window.location.href;

const getRealIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.warn('Could not fetch external IP:', error);
    return null;
  }
};

const sendTracking = async (customUrl = null) => {
  const timeSpent = Math.floor((Date.now() - pageStartTime) / 1000);
  const url = customUrl || window.location.href;

  const externalIP = await getRealIP();

  const payload = {
    url,
    referrer: document.referrer,
    time_spent: timeSpent,
    user_agent: navigator.userAgent,
    ...(externalIP && { external_ip: externalIP })
  };

  console.log('Tracking payload:', payload);

  const trackingUrl = process.env.REACT_APP_TRACKING_URL;

  try {
    const response = await fetch(trackingUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.warn(`Tracking server responded with status: ${response.status}`);
    } else {
      console.log('Tracking data sent successfully');
    }
  } catch (error) {
    console.warn('Tracking server unavailable:', error.message);
  }

  pageStartTime = Date.now();
  lastTrackedUrl = url;
};

const trackClick = (event) => {
  console.log('Click tracked on:', event.target);
  sendTracking().catch(error => {
    console.warn('Failed to send tracking data on click:', error.message);
  });
};

const setupClickTracking = () => {
  document.querySelectorAll('button').forEach(button => {
    button.addEventListener('click', trackClick);
  });

  document.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', trackClick);
  });

  document.querySelectorAll('.trackable, [data-track]').forEach(element => {
    element.addEventListener('click', trackClick);
  });
};

// For tracking on route change 
const patchHistoryMethod = (method) => {
    const original = window.history[method];
    window.history[method] = function (...args) {
    const result = original.apply(this, args);
    const newUrl = window.location.href;
    if (newUrl !== lastTrackedUrl) {
      sendTracking(newUrl);
    }
    return result;
  };
};

patchHistoryMethod('pushState');
patchHistoryMethod('replaceState');

window.addEventListener('popstate', () => {
  const newUrl = window.location.href;
  if (newUrl !== lastTrackedUrl) {
    sendTracking(newUrl);
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupClickTracking);
} else {
  setupClickTracking();
}

// Track time before unload as fallback
window.addEventListener('beforeunload', () => {
  const timeSpent = Math.floor((Date.now() - pageStartTime) / 1000);
  const payload = {
    url: window.location.href,
    referrer: document.referrer,
    time_spent: timeSpent,
    user_agent: navigator.userAgent,
  };

  const trackingUrl = process.env.REACT_APP_TRACKING_URL;
  if (trackingUrl && navigator.sendBeacon) {
    navigator.sendBeacon(trackingUrl, JSON.stringify(payload));
  }
});
